import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { useEffect, useState } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import LoaderAHSF from "../../Components/LoaderAHSF";
import InputAHSF from "../../Components/InputAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";

import TextAreaAHSF from "../../Components/TextAreaAHSF";
import {
  AddTechnicalReportNotesData,
  GetOneTechnicalReportNotes,
  restValidateTechnicalReportNotes,
  UpdateCanEdit,
  UpdateIsActive,
  ValidateTechnicalReportNotes,
} from "../../Redux/Reducers/ReportStage/TechnicalReportNotes";
import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import { GetAllPR_NotesTable } from "../../Redux/Reducers/ReportStage/NotesTableDropdown";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const AddEditTechnicalReportNotes = (props) => {
  const dispatch = useDispatch();
  let { stageGuid } = useParams();
  stageGuid = decryptToken(stageGuid);

  const loading = useSelector(
    (state) => state.TechnicalReportNotes.IsActiveTechnicalReportNotes
  );
  const loading2 = useSelector(
    (state) => state.TechnicalReportNotes.CanEditTechnicalReportNotes
  );
  const state = useSelector((state) => {
    return {
      //////////////////////////////////////////////////////////

      OneTechnicalReportNotes:
        state.TechnicalReportNotes.OneTechnicalReportNotes,
      TechnicalReportNotesValidate:
        state.TechnicalReportNotes.TechnicalReportNotesValidate,
      loadingOneTechnicalReportNotes:
        state.TechnicalReportNotes.loadingOneTechnicalReportNotes,
      PR_NotesTableDropDown: state.PR_NotesTableDropDown.PR_NotesTableDropDown,
      UpdateIsActive: state.TechnicalReportNotes.UpdateIsActive,
      UpdateCanEdit: state.TechnicalReportNotes.UpdateCanEdit,
    };
  });

  useEffect(() => {
    dispatch(GetAllPR_NotesTable());
  }, []);

  const [TechnicalReportNotesList, setTechnicalReportNotesList] = useState({
    pR_TechnicalReportNotesId:
      state.OneTechnicalReportNotes?.pR_TechnicalReportNotesId,
    pR_NotesTableId: state.OneTechnicalReportNotes?.pR_NotesTableId,
    notes: state.OneTechnicalReportNotes?.notes,
    timeAndDate: state.OneTechnicalReportNotes?.timeAndDate,
    incrementNumber: state.OneTechnicalReportNotes?.incrementNumber,
    canEdit: state.OneTechnicalReportNotes?.canEdit,
    isActive: state.OneTechnicalReportNotes?.isActive,
    // pR_ReportsStagesGuid: "78563532-98a0-480f-a656-7ba0fdc03c16",
    pR_ReportsStagesGuid: stageGuid,
  });
  const AddTechnicalReportNotes = async () => {
    const validationList = await dispatch(
      ValidateTechnicalReportNotes({
        pR_NotesTableId: TechnicalReportNotesList.pR_NotesTableId,

        notes: TechnicalReportNotesList.notes,
      })
    );

    if (validationList.payload.length === 0) {
      await dispatch(
        AddTechnicalReportNotesData({
          pR_NotesTableId: TechnicalReportNotesList.pR_NotesTableId,
          notes: TechnicalReportNotesList.notes,
          timeAndDate: TechnicalReportNotesList.timeAndDate,
          incrementNumber: TechnicalReportNotesList.incrementNumber,
          pR_ReportsStagesGuid: TechnicalReportNotesList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  const UpdateisActive = async () => {
    await dispatch(
      UpdateIsActive({
        pR_TechnicalReportNotesId:
          TechnicalReportNotesList.pR_TechnicalReportNotesId,
        isActive: TechnicalReportNotesList.isActive == true ? false : true,
        pR_ReportsStagesGuid: TechnicalReportNotesList.pR_ReportsStagesGuid,
        pR_NotesTableId: TechnicalReportNotesList.pR_NotesTableId,
        notes: TechnicalReportNotesList.notes,
        timeAndDate: TechnicalReportNotesList.timeAndDate,
        incrementNumber: TechnicalReportNotesList.incrementNumber,
        canEdit: TechnicalReportNotesList.canEdit,
      })
    );
  };
  const UpdatecanEdit = async () => {
    await dispatch(
      UpdateCanEdit({
        pR_TechnicalReportNotesId:
          TechnicalReportNotesList.pR_TechnicalReportNotesId,
        isActive: TechnicalReportNotesList.isActive,
        pR_ReportsStagesGuid: TechnicalReportNotesList.pR_ReportsStagesGuid,
        pR_NotesTableId: TechnicalReportNotesList.pR_NotesTableId,
        notes: TechnicalReportNotesList.notes,
        timeAndDate: TechnicalReportNotesList.timeAndDate,
        incrementNumber: TechnicalReportNotesList.incrementNumber,
        canEdit: TechnicalReportNotesList.canEdit == true ? false : true,
      })
    );
  };
  console.log(TechnicalReportNotesList.isActive, "active");

  useEffect(() => {
    dispatch(restValidateTechnicalReportNotes());
  }, []);
  useEffect(() => {
    if (props != null) {
      dispatch(GetOneTechnicalReportNotes(props.pR_TechnicalReportNotesId));
    }
  }, [props.pR_TechnicalReportNotesId, loading, loading2]);
  useEffect(() => {
    if (
      !state.loadingOneTechnicalReportNotes &&
      Object.keys(props).length != 0
    ) {
      setTechnicalReportNotesList({
        ...state.OneTechnicalReportNotes,
      });
    } else {
      setTechnicalReportNotesList({
        notes: null,
        pR_NotesTableId: null,
        canEdit: null,
        isActive: null,
        pR_ReportsStagesGuid: TechnicalReportNotesList.pR_ReportsStagesGuid,
      });
    }
  }, [state.OneTechnicalReportNotes]);

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );

  const shouldDisableFields = window.location.href.includes("manager") == true;

  //to render html after loading ends
  //   console.log(TechnicalReportNotesList?.isActive,"Active");
  console.log(TechnicalReportNotesList?.pR_TechnicalReportNotesId, "id");

  return (
    <>
      {!state.loadingOneTechnicalReportNotes ? (
        <>
          <div className="AddEdite">
            <AllDropDownsAHSF
              fieldsName="noteTable"
              show={true}
              disabled={
                TechnicalReportNotesList?.pR_TechnicalReportNotesId ||
                !shouldDisableFields
              }
              arrayOoptionList={state.PR_NotesTableDropDown}
              KeyText={"notesTable"}
              KeyValue={"pR_NotesTableId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setTechnicalReportNotesList({
                  ...TechnicalReportNotesList,
                  pR_NotesTableId: e.target.value,
                });
              }}
              defaultValue={TechnicalReportNotesList.pR_NotesTableId}
              showValidationMessage={
                state.TechnicalReportNotesValidate
                  ? state.TechnicalReportNotesValidate.includes("noteTable")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="note"
              show={true}
              disabled={
                TechnicalReportNotesList?.pR_TechnicalReportNotesId ||
                !shouldDisableFields
              }
              onChange={(e) => {
                setTechnicalReportNotesList({
                  ...TechnicalReportNotesList,
                  notes: e.target.value,
                });
              }}
              defaultValue={TechnicalReportNotesList?.notes}
              showValidationMessage={
                state.TechnicalReportNotesValidate
                  ? state.TechnicalReportNotesValidate.includes("note")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {/* {!shouldDisableFields ? ( */}
            {!TechnicalReportNotesList?.pR_TechnicalReportNotesId && (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      AddTechnicalReportNotes();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            )}
            {TechnicalReportNotesList?.pR_TechnicalReportNotesId &&
              shouldDisableFields && (
                <>
                  <div className="new-container">
                    <label className="toggle-container">
                      <input
                        title="dd"
                        type="checkbox"
                        defaultChecked={
                          TechnicalReportNotesList?.isActive === true
                            ? false
                            : TechnicalReportNotesList?.isActive === false
                            ? true
                            : null
                        }
                        onChange={(e) => {
                          console.log(e.target.checked, "checked");

                          setTechnicalReportNotesList({
                            ...TechnicalReportNotesList,
                            isActive: e.target.checked,
                          });
                        }}
                        onClick={() => {
                          UpdateisActive();
                        }}
                      />
                      <svg
                        className="icon-eye"
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 0 576 512"
                        title="dd"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
                      </svg>
                      <svg
                        className="icon-eye-slash"
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 0 640 512"
                        title="dd"
                      >
                        <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z" />
                      </svg>
                      <span className="active-title">
                        {" "}
                        {TechnicalReportNotesList?.isActive === true
                          ? "ظهور الملاحظة"
                          : "عدم ظهور الملاحظة"}
                      </span>
                    </label>
                    <div className="switch-wrapper">
                      <input
                        className="switch-checkbox"
                        type="checkbox"
                        id="toggle-switch"
                        defaultChecked={
                          TechnicalReportNotesList?.canEdit === true
                            ? true
                            : TechnicalReportNotesList?.canEdit === false
                            ? false
                            : null
                        }
                        onChange={(e) => {
                          console.log(e.target.checked, "checked");

                          setTechnicalReportNotesList({
                            ...TechnicalReportNotesList,
                            canEdit: e.target.checked,
                          });
                        }}
                        onClick={() => {
                          UpdatecanEdit();
                        }}
                      />
                      <label
                        className="switch-container"
                        htmlFor="toggle-switch"
                      >
                        <div className="switch-button">
                          <div className="switch-button-circles-wrapper">
                            {Array(12)
                              .fill(null)
                              .map((_, index) => (
                                <div
                                  className="switch-button-circle"
                                  key={index}
                                ></div>
                              ))}
                          </div>
                        </div>
                      </label>
                      <span className="edit-title">
                        {TechnicalReportNotesList?.canEdit === true
                          ? "السماح بالتعديل"
                          : "عدم السماح بالتعديل"}
                      </span>
                    </div>
                  </div>
                </>
              )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneTechnicalReportNotes} />
    </>
  );
};

export default AddEditTechnicalReportNotes;
